import { render } from "./YieldForm.vue?vue&type=template&id=61b2d36e&ts=true"
import script from "./YieldForm.vue?vue&type=script&lang=ts"
export * from "./YieldForm.vue?vue&type=script&lang=ts"

import "./YieldForm.vue?vue&type=style&index=0&id=61b2d36e&lang=css"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__